import { abilitiesPlugin } from '@casl/vue'
import { useAuthStore } from '~/stores/auth'

/**
 * The signed-in person's permissions, as the CASL rules `GET /v2/access/me`
 * returns. One ability for the whole app, which screens ask through useCan().
 *
 * The plugin holds the access query's one long-lived observer, so the rules
 * refresh on the /users/me schedule and on window focus wherever the person
 * is. Signed out, the ability holds no rules and every check answers no.
 *
 * `enforce: 'post'` runs it after vue-query.client.ts, whose QueryClient the
 * access query needs.
 */
export default defineNuxtPlugin({
  name: 'casl',
  enforce: 'post',
  setup(nuxtApp) {
    const ability = createAccessAbility()
    nuxtApp.vueApp.use(abilitiesPlugin, ability)

    const authStore = useAuthStore()
    const { data: access } = useAccessMeQuery(() => authStore.isAuthenticated)

    watch(
      [access, () => authStore.isAuthenticated],
      ([current, isAuthenticated]) => {
        ability.update(
          isAuthenticated && current ? unpackAccessRules(current.rules) : [],
        )
      },
      { immediate: true },
    )
  },
})
